export const SUPPORT_HINT = "Попробуйте позже или обратитесь в поддержку.";

/**
 * Transforms technical, validation, or raw API errors into clean, friendly Russian messages
 * suitable for end-users, appending the standard support hint when appropriate.
 */
export function formatUserErrorMessage(
  err: unknown,
  fallbackAction = "Произошла ошибка",
): string {
  let rawMessage = "";

  if (typeof err === "string") {
    rawMessage = err.trim();
  } else if (
    err &&
    typeof err === "object" &&
    "message" in err &&
    typeof (err as { message?: unknown }).message === "string"
  ) {
    rawMessage = ((err as { message: string }).message || "").trim();
  }

  if (!rawMessage) {
    return `${fallbackAction}. ${SUPPORT_HINT}`;
  }

  const lower = rawMessage.toLowerCase();

  // 1. Language validation
  if (
    lower.includes("languages must include") ||
    lower.includes("at least one of ru, en") ||
    lower.includes("хотя бы один язык")
  ) {
    return "Выберите хотя бы один язык вакансий (RU или EN).";
  }
  if (lower.includes("languages contains an invalid")) {
    return "Некорректный язык вакансий. Выберите RU или EN.";
  }

  // 2. Seniority validation
  if (lower.includes("seniorities contains an invalid")) {
    return "Некорректный грейд. Выберите подходящие грейды из списка.";
  }

  // 3. Skills validation
  if (lower.includes("skills must have at most")) {
    return "Можно указать не более 20 навыков.";
  }
  if (lower.includes("skills entries must be at most")) {
    return "Название навыка не должно превышать 64 символов.";
  }
  if (lower.includes("skills must not contain duplicate")) {
    return "Навыки не должны повторяться.";
  }
  if (lower.includes("skills entries must not be empty")) {
    return "Навык не может быть пустым.";
  }

  // 4. Exclusions validation
  if (lower.includes("exclusions must have at most")) {
    return "Можно указать не более 20 стоп-слов.";
  }
  if (lower.includes("exclusion value must be at most")) {
    return "Стоп-слово не должно превышать 64 символов.";
  }
  if (lower.includes("exclusions must not contain duplicate")) {
    return "Стоп-слова не должны повторяться.";
  }
  if (lower.includes("exclusion value must be a non-empty")) {
    return "Стоп-слово не может быть пустым.";
  }

  // 5. Specialization validation
  if (
    lower.includes("выберите специализацию") ||
    lower.includes("specialization must be")
  ) {
    return "Пожалуйста, выберите специализацию из списка.";
  }
  if (
    lower.includes("у вас уже есть профиль") ||
    lower.includes("duplicatespecializationalerterror") ||
    lower.includes("already exists")
  ) {
    return "У вас уже есть профиль для этой специализации.";
  }
  if (
    lower.includes("лимит профилей") ||
    lower.includes("jobalertlimitexceedederror") ||
    lower.includes("limit reached")
  ) {
    return "Достигнут лимит профилей (максимум 5).";
  }

  // 7. Auth & Subscription
  if (
    lower.includes("subscription required") ||
    lower.includes("требуется подписка")
  ) {
    return "Для этого действия требуется активная подписка.";
  }
  if (lower.includes("unauthorized") || lower.includes("не авторизован")) {
    return "Сессия истекла. Пожалуйста, перезапустите приложение.";
  }

  // 8. Technical / Database / Prisma / Network / 500 errors
  const isTechnical =
    lower.includes("prisma") ||
    lower.includes("constraint") ||
    lower.includes("foreign key") ||
    lower.includes("syntaxerror") ||
    lower.includes("typeerror") ||
    lower.includes("internal error") ||
    lower.includes("internal server error") ||
    lower.includes("failed with status") ||
    lower.includes("failed to fetch") ||
    lower.includes("networkerror") ||
    lower.includes("econnrefused") ||
    /[a-zA-Z]{4,}/.test(rawMessage); // Any Latin/English error string

  if (isTechnical) {
    return `${fallbackAction}. ${SUPPORT_HINT}`;
  }

  // 9. User-readable Russian string that might need the support hint appended
  if (!rawMessage.includes("поддержк") && !rawMessage.includes("позже")) {
    const clean = rawMessage.replace(/\.+$/, "");
    return `${clean}. ${SUPPORT_HINT}`;
  }

  return rawMessage;
}
